// call to app
const baseURL = `${window.location.origin}/apps/${APP_PROXY_NAME}`;
window.airship = {
  triggerCheckoutStartedEventInAirship: async ({
    namedUserId = shopifyCustomer.customerId || localStorage.getItem("vinyl_customer_id_from_subscribe"),
    productsInCart,
    checkoutUrl,
    cartSubtotalLocal,
    cartTotalLocal,
    cartDiscountLocal,
  }) => {
    try {
      //call post to baseURL
      fetch(`${baseURL}/app/airship`, {
        method: "POST",
        body: JSON.stringify({
          action: "checkout_started",
          data: {
            namedUserId: namedUserId || "",
            productsInCart,
            checkoutUrl,
            cartSubtotalLocal,
            cartTotalLocal,
            cartDiscountLocal,
          },
        }),
      }).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      });
    } catch (error) {
      console.error(
        `Error triggering Checkout Started event in Airship: ${error}`
      );
      console.log(error);
    }
  },
  triggerAddedToCartEventInAirship: async ({
    namedUserId = shopifyCustomer.customerId || localStorage.getItem("vinyl_customer_id_from_subscribe"),
    productsInCart,
    checkoutUrl,
    cartSubtotalLocal,
    cartTotalLocal,
    cartDiscountLocal,
  }) => {
    try {
      //call post to baseURL
      fetch(`${baseURL}/app/airship`, {
        method: "POST",
        body: JSON.stringify({
          action: "added_to_cart",
          data: {
            namedUserId: namedUserId || "",
            productsInCart,
            checkoutUrl,
            cartSubtotalLocal,
            cartTotalLocal,
            cartDiscountLocal,
          },
        }),
      }).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      });
    } catch (error) {
      console.error(
        `Error triggering Added to Cart event in Airship: ${error}`
      );
      console.log(error);
    }
  },
  associateNamedUserInAirship: async ({
    namedUserId = shopifyCustomer.customerId || localStorage.getItem("vinyl_customer_id_from_subscribe"),
    currency= window.Shopify.currency.active || "USD",
    country,
  }) => {
    try {
      if(country){
        switch(country){
          case "CA":
            currency = "CAD";
            break;
          case "AU":
            currency = "AUD";
            break;
          case "GB":
            currency = "GBP";
            break;
          case "US":
            currency = "USD";
            break;
          default:
            currency = "USD";
            break;
        }
      }
      //call post to baseURL
      fetch(`${baseURL}/app/airship`, {
        method: "POST",
        body: JSON.stringify({
          action: "associate_named_user",
          data: {
            namedUserId: String(namedUserId) || "",
            currency,
          },
        }),
      }).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      });
    } catch (error) {
      console.error(
        `Error associating Named User in Airship: ${error}`
      );
      console.log(error);
    }
  },
  registerEmailChannelInAirship: async ({
    address = shopifyCustomer.email,
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
    localeCountry = window.Shopify.country,
  }) => {
    try {
      //call post to baseURL
      fetch(`${baseURL}/app/airship`, {
        method: "POST",
        body: JSON.stringify({
          action: "register_email_channel",
          data: {
            namedUserId: shopifyCustomer.customerId,
            address,
            timezone,
            localeCountry,
          },
        }),
      }).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      });
    } catch (error) {
      console.error(
        `Error registering Email Channel in Airship: ${error}`
      );
      console.log(error);
    }
  }
};
